import moment from "moment"

import { ICommercialOffers } from "./types"

import { ComponentsHeader } from "@primitive/sectionHeadings"
import { useDeviceType } from "@hooks/useDeviceType"

import { Flex, Loader, Button, Empty, Pagination, ToolTip, Table } from "@ui/index"

import imgEmty from '@img/empty.svg'
import logoYaSkill from '@img/logo_yaskill.svg'
import logoModSkill from '@img/logo_modskill.svg'
import { IconKP, IconTelegram } from "@img/icons"
import imgAccessDenied from '@img/access_denied.svg'

import css from './ui.module.scss'


/** Коммерческие предложения */
export const CommercialOffers = ({
    isAccessDenied, txtSearch, setTxtSearch, 
    commercialOffersCreated, commercialOffersDelayedCall, commercialOffersSended,
    commercialOffersExecutionContract, commercialOffersCanceled,
    commercialOffersList, isLoading, paginationPageNumber, totalCount, pageSize,
    filterIsOpen, filterIsActivate,
    loadPrimaryData, handleOpenCardMain, handlerOpenModalConfirm,
    handleApplyClearFilter
}: ICommercialOffers) => {
    const deviceType = useDeviceType()

    /** Вазвращает лого сайта */
    const returnLogo = (dbName: string) => {
        switch (dbName) {
            case 'modern_academy': return logoModSkill
            case 'yaskill': return logoYaSkill
        }
    }

    const footer = (
        <div className={css['footer']}>
            <Flex gap="4px" flexDirection="row">
                <ToolTip title='Общее количество' placement="topLeft">
                    <p className={css['stat_all']}>{totalCount}</p>
                </ToolTip>

                {commercialOffersCreated > 0 && 
                    <ToolTip title='Создан' placement="topLeft">
                        <p className={css['stat_new']}>{commercialOffersCreated}</p>
                    </ToolTip>
                }

                {commercialOffersDelayedCall > 0 && 
                    <ToolTip title='Отложенный звонок' placement="topLeft">
                        <p className={css['stat_delayed']}>{commercialOffersDelayedCall}</p>
                    </ToolTip>
                }

                {(commercialOffersSended > 0 && deviceType !== 'mobile') && 
                    <ToolTip title='Отправлено' placement="topLeft">
                        <p className={css['stat_sended']}>{commercialOffersSended}</p>
                    </ToolTip>
                }

                {commercialOffersExecutionContract > 0 && 
                    <ToolTip title='Заключён договор' placement="topLeft">
                        <p className={css['stat_execution_contract']}>{commercialOffersExecutionContract}</p>
                    </ToolTip>
                }

                {(commercialOffersCanceled > 0 && deviceType !== 'mobile') && 
                    <ToolTip title='Отказ' placement="topLeft"> 
                        <p className={css['stat_canceled']}>{commercialOffersCanceled}</p>
                    </ToolTip>
                }
            </Flex>

            <Pagination
                totalCount={totalCount}
                pageSize={pageSize}
                currentPage={paginationPageNumber.value}
                onChange={(e) => paginationPageNumber.setValue(e)}
            />
        </div>
    )

    return <div className={css['container']}>

        <ComponentsHeader
            isAccessDenied={isAccessDenied.value}
            headerIcon={<IconKP width="20px" height="20px" />}
            headerTitle="Ком. предложения"
            txtSearch={txtSearch}
            txtSearchTooltip={<>Поиск по:<br />✓ Номеру заявки<br />✓ Имени клиента<br />✓ Телефону клиента<br />✓ Email клиента<br />✓ Имени курса<br />✓ Комментарию</>}
            txtSearchOnChange={(e) => setTxtSearch(e.target.value)}
            txtSearchClearOnClick={() => setTxtSearch('')}
            btnUpdateOnClick={() => loadPrimaryData(txtSearch)}
            btnCreateOnClick={() => handleOpenCardMain(true, "new")}
            btnFilterOnClick={() => filterIsOpen.setValue(true)}
            btnFilterClearOnClick={() => handleApplyClearFilter('clear')}
            filterIsActivate={filterIsActivate.value}
        />

        <Table.Container footer={footer} footerPlacement='page'>
            <Loader isOpen={isLoading} backdrop title="Загрузка..." />
            <Table.Header paddingLeft="57px" paddingRight="66px" classNameContainer={css['hidden_600']} classNameContent={css['table_grid_columns_header']}>
                <p style={{textAlign: 'center'}}>№ КП</p>
                <p style={{textAlign: 'center'}}>№ заявки<br />Дата КП</p>
                <p>Телефон<br />Электронная почта</p>
                <p className={css['hidden_850']}>Кому<br />Комментарий</p>
                <p className={css['hidden_1050']} style={{textAlign: 'center'}}>Отложенный звонок</p>
                <p className={css['hidden_1150']} style={{textAlign: 'center'}}>Статус КП</p>
                <p className={css['hidden_950']} style={{textAlign: 'center'}}>Дата создания</p>
            </Table.Header>

            <Table.Content>
                {commercialOffersList.length === 0
                    ? <Empty image={isAccessDenied.value === false ? imgEmty : imgAccessDenied} title={isAccessDenied.value === false ? 'Данные отсутствуют' : 'Доступ запрещён'} />
                    : commercialOffersList.map((item) => (
                        <Table.Row key={item.commercialOfferID} className={css['table_grid_columns_content']} onClick={() => handleOpenCardMain(true, "edit", item.commercialOfferID)}>
                            <img src={returnLogo(item.siteDbName)} alt="Лого сайта" width={24} height={24} />

                            <p style={{
                                color: '#ffffff',
                                textAlign: 'center',
                                lineHeight: '200%',
                                background: item.commercialOffersStatusColor,
                                borderRadius: 'calc(var(--border_radius_default) - 4px)',
                            }}>{item.commercialOfferID}</p>

                            <div className={css['hidden_600']} style={{textAlign: 'center'}}>
                                <p>{item.applicationID || '------'}</p>
                                <p>{item.commercialOfferDate}</p>
                            </div>

                            <div style={{textWrap: 'nowrap', overflow: 'hidden'}}>
                                <p>{item.phone || '------'}</p>
                                <p>{item.email || '------'}</p>
                            </div>

                            <div className={css['hidden_850']} style={{textWrap: 'nowrap', overflow: 'hidden'}}>
                                <p>{item.toWhom || '------'}</p>
                                <p>{item.comment || '------'}</p>
                            </div>

                            <div className={css['hidden_1050']} style={{textAlign: 'center'}}>
                                <p>{item.dateNextCall || '--.--.----'}</p>
                                <p>{item.timeNextCall || '--:--:--'}</p>
                            </div>

                            <p className={css['hidden_1150']} style={{
                                textAlign: 'center', 
                                fontWeight: '600', 
                                color: item.commercialOffersStatusColor
                            }}>{item.commercialOffersStatusName}</p>
                            
                            <div className={css['hidden_950']} style={{textAlign: 'center'}}>
                                <p>{moment(item.dateCreate).format('DD.MM.YYYY')}</p>
                                <p>{moment(item.dateCreate).format('HH:mm:ss')}</p>
                            </div>

                            <Flex gap="2px" flexDirection="row" alignItems="center" justifyContent="center">
                                <ToolTip title='ИКТ - КП клиенту' placement="bottomRight">
                                    <Button id='tooltipBtnMailings' variant="icon" size={deviceType === 'mobile' ? 'xs' : 'sm'} onClick={(e) => {
                                        handlerOpenModalConfirm(true, 'Отправка информации', 'Вы действительно хотите отправить информацию в telegram канал?', 'sendedTelegram', item.commercialOfferID)
                                        e.stopPropagation()
                                    }}><IconTelegram width={deviceType === 'mobile' ? '16px' : '20px'} height={deviceType === 'mobile' ? '16px' : '20px'} /></Button>
                                </ToolTip>
                            </Flex>
                        </Table.Row>
                    ))
                }
            </Table.Content>
        </Table.Container>

        
    </div>
}
